import { darkTheme, lightTheme } from '../../theme';
import { DARK } from '../../utils/constants';

export const menuStyles = theme => {
  const currentTheme = theme === DARK ? darkTheme : lightTheme;

  return {
    bmBurgerButton: {
      position: 'fixed',
      width: '26px',
      height: '26px',
      right: '36px',
      top: '22px',
    },
    bmBurgerBars: {
      background: currentTheme.palette.brand.secondary,
    },
    bmBurgerBarsHover: {
      background: currentTheme.palette.brand.secondary,
    },
    bmCrossButton: {
      width: '26px',
      height: '26px',
      right: '36px',
      top: '22px',
    },
    bmCross: {
      background: currentTheme.palette.secondary.light3,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    bmMenuWrap: {
      position: 'fixed',
      height: '100%',
    },
    bmMenu: {
      background: currentTheme.palette.secondary.light3,
      padding: '40px 10px 0',
      fontSize: '18px',
      lineHeight: '28px',
    },
    bmMorphShape: {
      fill: currentTheme.palette.secondary.dark2,
    },
    bmItemList: {
      color: currentTheme.palette.secondary.main3,
      padding: '18px 0 18px 0',
      display: 'flex',
      flexDirection: 'column',
    },
    bmItem: {
      display: 'block',
    },
    bmOverlay: {
      background: 'rgba(0, 0, 0, 0.3)',
    },
  };
};
